/* ============================================================
   CIGARE GENTLEMAN — BANNIÈRE DÉFILANTE LUXE
   Asset JS externalisé pour bypass complet du minify_html.
   Session 3c.1 (06/05/2026)
   ============================================================ */

(function() {
  if (window._cgBanniereInjected) return;
  window._cgBanniereInjected = true;

  /* === CSS injecté dans <head> === */
  var css = ''
    + '.cg-luxe-marquee {'
    + '  width:100% !important;'
    + '  background-color:#0a0a0a !important;'
    + '  color:#c8ad68 !important;'
    + '  font-family:Inter,"Helvetica Neue",Arial,sans-serif !important;'
    + '  overflow:hidden !important;'
    + '  position:relative !important;'
    + '  padding:12px 0 !important;'
    + '  z-index:9999 !important;'
    + '  display:flex !important;'
    + '  border-bottom:1px solid rgba(200,173,104,0.18) !important;'
    + '}'
    + '.cg-marquee-track {'
    + '  display:flex !important;'
    + '  width:max-content !important;'
    + '  animation:cg-infinite-scroll 50s linear infinite !important;'
    + '}'
    + '.cg-luxe-marquee:hover .cg-marquee-track {'
    + '  animation-play-state:paused !important;'
    + '}'
    + '.cg-marquee-group {'
    + '  display:flex !important;'
    + '  align-items:center !important;'
    + '  flex-shrink:0 !important;'
    + '}'
    + '.cg-marquee-item {'
    + '  display:flex !important;'
    + '  align-items:center !important;'
    + '  font-size:12px !important;'
    + '  font-weight:700 !important;'
    + '  letter-spacing:1.8px !important;'
    + '  text-transform:uppercase !important;'
    + '  color:#c8ad68 !important;'
    + '  white-space:nowrap !important;'
    + '}'
    + '.cg-marquee-svg {'
    + '  width:16px !important;'
    + '  height:16px !important;'
    + '  margin-right:10px !important;'
    + '  color:#c8ad68 !important;'
    + '  flex-shrink:0 !important;'
    + '}'
    + '.cg-marquee-dot {'
    + '  margin:0 40px !important;'
    + '  color:rgba(200,173,104,0.4) !important;'
    + '  font-size:16px !important;'
    + '}'
    + '@keyframes cg-infinite-scroll {'
    + '  0% { transform:translateX(0); }'
    + '  100% { transform:translateX(-50%); }'
    + '}'
    + '@media (max-width:768px) {'
    + '  .cg-luxe-marquee { padding:10px 0 !important; }'
    + '  .cg-marquee-item { font-size:10.5px !important; letter-spacing:1.2px !important; }'
    + '  .cg-marquee-svg { width:14px !important; height:14px !important; margin-right:8px !important; }'
    + '  .cg-marquee-dot { margin:0 25px !important; }'
    + '}';

  /* Inject CSS */
  var styleEl = document.createElement('style');
  styleEl.id = 'cg-banniere-style';
  styleEl.textContent = css;
  (document.head || document.documentElement).appendChild(styleEl);

  /* === Items configuration === */
  var items = [
    {
      svg: '<svg class="cg-marquee-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M11.48 3.5a.56.56 0 011.04 0l2.13 5.11a.56.56 0 00.47.34l5.52.45c.5.04.7.66.32.99l-4.2 3.6a.56.56 0 00-.18.69l1.15 5.07c.1.46-.39.81-.81.57L12 17.34l-4.7 2.97c-.42.24-.91-.11-.81-.57l1.15-5.07a.56.56 0 00-.18-.69l-4.2-3.6c-.38-.33-.18-.95.32-.99l5.52-.45a.56.56 0 00.47-.34L11.48 3.5z"></path></svg>',
      text: 'ACCESSOIRES CIGARES PREMIUM'
    },
    {
      svg: '<svg class="cg-marquee-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="9" width="13" height="9" rx="0.5"></rect><path stroke-linecap="round" stroke-linejoin="round" d="M15 12h5l1.5 2v4H15z"></path><circle cx="6" cy="19" r="1.5"></circle><circle cx="17.5" cy="19" r="1.5"></circle></svg>',
      text: 'LIVRAISON OFFERTE EN UE'
    },
    {
      svg: '<svg class="cg-marquee-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="11" width="18" height="11" rx="2"></rect><path stroke-linecap="round" stroke-linejoin="round" d="M7 11V7a5 5 0 0110 0v4"></path></svg>',
      text: 'PAIEMENT 100% S\u00C9CURIS\u00C9'
    },
    {
      svg: '<svg class="cg-marquee-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M12 2.5l8 3.5v6c0 5-3.5 8.5-8 9.5-4.5-1-8-4.5-8-9.5V6l8-3.5z"></path><path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4"></path></svg>',
      text: 'SAVOIR-FAIRE'
    },
    {
      svg: '<svg class="cg-marquee-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="8" width="18" height="13" rx="0.5"></rect><path stroke-linecap="round" stroke-linejoin="round" d="M3 12h18"></path><path stroke-linecap="round" stroke-linejoin="round" d="M12 8v13"></path><path stroke-linecap="round" stroke-linejoin="round" d="M7.5 8c-1.5-2.5 0-5 2-5 1.5 0 2.5 2 2.5 5"></path><path stroke-linecap="round" stroke-linejoin="round" d="M16.5 8c1.5-2.5 0-5-2-5-1.5 0-2.5 2-2.5 5"></path></svg>',
      text: 'PACK -20%'
    },
    {
      svg: '<svg class="cg-marquee-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M3 12a9 9 0 1 0 3-6.7"></path><path stroke-linecap="round" stroke-linejoin="round" d="M3 4v5h5"></path><path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3l2 2"></path></svg>',
      text: 'RETOUR & \u00C9CHANGE 30 JOURS'
    }
  ];

  /* === Build group HTML === */
  function buildGroupHTML(ariaHidden) {
    var html = '<div class="cg-marquee-group"' + (ariaHidden ? ' aria-hidden="true"' : '') + '>';
    items.forEach(function(item) {
      html += '<div class="cg-marquee-item">' + item.svg + item.text + '</div>';
      html += '<div class="cg-marquee-dot">\u2022</div>';
    });
    html += '</div>';
    return html;
  }

  /* === Inject HTML === */
  function injectMarquee() {
    if (document.querySelector('.cg-luxe-marquee')) return;
    if (!document.body) return;

    var marqueeHTML = '<div class="cg-luxe-marquee"><div class="cg-marquee-track">'
      + buildGroupHTML(false)
      + buildGroupHTML(true)
      + '</div></div>';

    var wrapper = document.createElement('div');
    wrapper.innerHTML = marqueeHTML;
    var marqueeEl = wrapper.firstChild;

    if (document.body.firstChild) {
      document.body.insertBefore(marqueeEl, document.body.firstChild);
    } else {
      document.body.appendChild(marqueeEl);
    }

    console.log('[CG Banniere] Injectee en haut du body');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectMarquee);
  } else {
    injectMarquee();
  }
  window.addEventListener('load', function() {
    setTimeout(injectMarquee, 200);
  });
})();